import { useAuth } from "../../../context";
import { EmissionsInsightsApi } from "../../../api/emissions-insights/emissions-insights-api";
import { useQuery } from "react-query";
import { is } from "utils";

export const emissionsInsightsKey = {
  emissionTotal: () => ["emissionTotal"],
  supplierOverview: () => ["supplierOverview"],
  supplierEngagementReport: () => ["supplierEngagementReport"],
};

export function useGetTotalEmissions(year, dimensionItemIds, config) {
  const { callApi } = useAuth();

  return useQuery(
    [...emissionsInsightsKey.emissionTotal(), dimensionItemIds, year],
    () => callApi(EmissionsInsightsApi.getEmissionsTotal, { year, dimensionItemIds }),
    config
  );
}

export function useGetSupplierOverviewData(years, categories, dataQuality, scope, config) {
  const { callApi } = useAuth();
  // HACK if years is unset, then default: do not fetch
  if (!is(config.enabled)) {
    const enabled = !!(years && years.length > 0 && years[0]); // [null,NaN] => not-enabled
    config = Object.assign({}, config, { enabled });
  }
  return useQuery(
    [...emissionsInsightsKey.supplierOverview(), years, categories, dataQuality, scope],
    () => callApi(EmissionsInsightsApi.getSupplierOverview, { years, categories, dataQuality, scope }),
    config
  );
}

export function useGetSupplierEngagementReport(years, supplierId, config) {
  const { callApi } = useAuth();

  return useQuery(
    [...emissionsInsightsKey.supplierEngagementReport(), years, supplierId],
    () => callApi(EmissionsInsightsApi.getSupplierEngagementReports, { years, supplierId }),
    config
  );
}
